import React from 'react';

export default function EventCard({ event, onSelect }) {
  const { title, date, time, location, short_description, price, image, status } = event;

  // Format date nicely for display (e.g. "18. apr 2026")
  const formatDate = (dateStr) => {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString('da-DK', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) {
      return dateStr;
    }
  };

  const imageUrl = image && image[0] ? image[0] : 'https://assets.auxodev.dk/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-1920x900-7n-1.webp';

  return (
    <div className="bg-brand-cream rounded-2xl overflow-hidden border border-brand-sand shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full">
      {/* Event Image */}
      <div className="relative aspect-[16/10] overflow-hidden bg-brand-sand">
        <img 
          src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/${imageUrl.replace('https://assets.auxodev.dk/', '')}`} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-[1.03]"
          loading="lazy"
        />
        {/* Status Badge */}
        <div className="absolute top-4 right-4">
          <span className={`px-3 py-1 rounded-full text-xs font-semibold tracking-wide uppercase shadow-sm ${
            status === 'kommende' 
              ? 'bg-brand-green text-brand-cream' 
              : 'bg-brand-muted/20 text-brand-muted backdrop-blur-sm'
          }`}>
            {status === 'kommende' ? 'Kommende' : 'Afholdt'}
          </span>
        </div>
      </div>

      {/* Event Content */}
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="font-display text-2xl text-brand-dark mb-3 leading-tight tracking-wide">
          {title}
        </h3>

        {/* Event Details */}
        <div className="space-y-2 mb-4 text-sm text-brand-muted font-sans">
          <p className="flex items-center gap-2.5">
            <i className="fa-light fa-calendar text-brand-green w-4" />
            <span>{formatDate(date)}</span>
          </p>
          <p className="flex items-center gap-2.5">
            <i className="fa-light fa-clock text-brand-green w-4" />
            <span>{time}</span>
          </p>
          <p className="flex items-start gap-2.5">
            <i className="fa-light fa-location-dot text-brand-green w-4 mt-0.5" />
            <span className="line-clamp-1">{location}</span>
          </p>
        </div>

        <p className="text-brand-muted text-sm leading-relaxed mb-6 font-sans line-clamp-3 flex-grow">
          {short_description}
        </p>

        {/* Footer & CTA */}
        <div className="pt-4 border-t border-brand-sand flex items-center justify-between gap-4 mt-auto">
          <div>
            <span className="block text-xs text-brand-muted uppercase tracking-wider font-sans">Pris</span>
            <span className="font-sans text-lg font-semibold text-brand-dark">{price}</span>
          </div>
          <button
            onClick={() => onSelect(event)}
            className={`px-5 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all duration-300 ${
              status === 'kommende'
                ? 'bg-brand-green hover:bg-brand-green/90 text-brand-cream shadow-sm hover:shadow-md'
                : 'bg-brand-sand hover:bg-brand-beige text-brand-dark/80'
            }`}
          >
            {status === 'kommende' ? 'Tilmeld dig' : 'Læs mere'}
          </button>
        </div>
      </div>
    </div>
  );
}
